import { FC, useEffect } from 'react';
import { SETTINGS_FILTERS } from 'utils/constants';
import useConsolidatedProjectsList from 'Pages/ProjectsListPage/hooks/useConsolidatedProjectsList/useConsolidatedProjectsList';
import { useQuickFilters } from 'Pages/ProjectsListPage/hooks/useQuickFilters/useQuickFilters';
import AppliedProjectsTableFilters from '../ActiveProjects/components/AppliedProjectsTableFilters/AppliedProjectsTableFilters';
import ProjectsTable from '../ActiveProjects/components/ProjectsTable';
import ProjectsTableFooter from '../ActiveProjects/components/ProjectsTableFooter';
import ProjectsTableOperationHeader from '../ActiveProjects/components/ProjectsTableOperationHeader/ProjectsTableOperationHeader';

interface ConsolidatedProjectsProps {
  handleAddProject: () => void;
  onOpenCancelModal?: (projectId: string) => void;
  onOpenOnHoldModal?: (projectId: string) => void;
  onOpenCloseModal?: (projectId: string) => void;
}

const ConsolidatedProjects: FC<ConsolidatedProjectsProps> = ({
  handleAddProject,
  onOpenCancelModal,
  onOpenOnHoldModal,
  onOpenCloseModal,
}) => {
  const {
    init,
    projects,
    totalProjectsCount,
    loadedProjectsCount,
    handleSort,
    isLoading,
    toggleSidePanelFilters,
    canFetchMoreProjects,
    fetchMoreProjects,
    searchProjects,
    searchValue,
    handleResetState,
    refreshProjectsList,
  } = useConsolidatedProjectsList();

  const { quickFilterButtons } = useQuickFilters({
    filterTypeKey: SETTINGS_FILTERS.CONSOLIDATED_PROJECTS_TABLE,
  });

  useEffect(() => {
    init();
    return () => handleResetState();
  }, [init, handleResetState]);

  return (
    <>
      {!isLoading && (
        <ProjectsTableOperationHeader
          tableName='consolidated-projects'
          onSearchChange={searchProjects}
          appliedSearchValue={searchValue}
          toggleSidePanelFilters={toggleSidePanelFilters}
          quickFilterButtons={quickFilterButtons}
          canFilter
        />
      )}
      {!isLoading && (
        <AppliedProjectsTableFilters
          isConsolidatedView
          tableName='consolidated-projects'
        />
      )}
      <ProjectsTable
        tableName='consolidated-projects'
        projects={projects}
        fetchMoreProjects={fetchMoreProjects}
        handleSort={handleSort}
        onAddProject={handleAddProject}
        isConsolidatedView
        isLoading={isLoading}
        canFetchMoreProjects={canFetchMoreProjects}
        onOpenCancelModal={onOpenCancelModal}
        onOpenOnHoldModal={onOpenOnHoldModal}
        onOpenCloseModal={onOpenCloseModal}
        onRefresh={refreshProjectsList}
      />
      <ProjectsTableFooter
        total={totalProjectsCount}
        loaded={loadedProjectsCount}
      />
    </>
  );
};

export default ConsolidatedProjects;
